import React from "react";
import MessageError from "../../message/__errors";
import "./styles.css";

// Чекбокс. value — булево; onChange получает нативное событие (e.target.checked).
export default function InputCheckbox({ value = false, children, errors, className = '', readOnly = false, onChange, ...other }) {
    return <>
        <label className={`input-checkbox ${className}`}>
            <input
                {...other}
                type="checkbox"
                className="input-checkbox__control"
                checked={!!value}
                disabled={readOnly}
                onChange={onChange}
            />
            <span className="input-checkbox__label">{children}</span>
        </label>
        {errors ? <MessageError errors={errors}/> : null}
    </>;
}
